import styled from 'styled-components'

type HalfDonutChartProps = {
  $fillColor: string
  $trackColor: string
  $percent: number
  $size: number
}

export const ChartWrapper = styled.div<{
  color: string
  size: number
}>`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  position: relative;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size / 2}px;
  color: ${({ color }) => color};
  font-size: 22px;
  font-weight: 600;
`

export const HalfDonutChart = styled.div<HalfDonutChartProps>`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    width: 100%;
    height: ${({ $size }) => $size}px;
    border: ${({ $size }) => $size / 5}px solid;
    border-color: ${({ $trackColor, $fillColor }) =>
      `${$trackColor} ${$trackColor} ${$fillColor} ${$fillColor}`};
    position: absolute;
    border-radius: 50%;
    left: 0;
    top: 0;
    box-sizing: border-box;
    transform: rotate(${({ $percent }) => $percent * 1.8 - 45}deg);
    transition: transform 1s;
  }

  &::before {
    content: '';
    width: 100%;
    height: ${({ $size }) => $size}px;
    border: ${({ $size }) => $size / 5}px solid
      ${({ $trackColor }) => $trackColor};
    position: absolute;
    border-radius: 50%;
    left: 0;
    top: 0;
    box-sizing: border-box;
    transform: rotate(-45deg);
    z-index: 0;
  }

  & > span {
    position: absolute;
    left: 50%;
    top: 100%;
    transform: translate(-50%, 10%);
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
    pointer-events: none;
  }
`

export const CornerLabel = styled.span<{
  position: 'left' | 'right'
  $fontSize: string
  $lineHeight: string
  $color: string
}>`
  position: absolute;
  bottom: 20%;
  left: ${({ position }) => (position === 'left' ? '0' : '100%')};
  transform: ${({ position }) =>
    position === 'left' ? 'translate(20%, 10px)' : 'translate(-120%, 10px)'};
  color: #ffffff;
  font-family: Barlow;
  font-weight: 400;
  white-space: nowrap;
  ${({ $fontSize }) => $fontSize && `font-size: ${$fontSize};`}
  ${({ $lineHeight }) => $lineHeight && `line-height: ${$lineHeight};`}
  ${({ $color }) => $color && `color: ${$color};`}
`
